/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Module_Bacnet_Device_IdInputs */



/**
* | output |
* | --- |
* | "BACnet device ID: {id}" |
*
* @param {Module_Bacnet_Device_IdInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_bacnet_device_id = /** @type {((inputs: Module_Bacnet_Device_IdInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Bacnet_Device_IdInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`BACnet device ID: ${i?.id}`)
	return /** @type {LocalizedString} */ (`Identifiant BACnet : ${i?.id}`)
});